import { language } from "shared/language";

export const API_EXISTED = language.api_existed;
export const API_NOT_FOUND = language.api_not_found;
